import { create } from "zustand";
import * as api from "../api/members";
import type { Member, WorkspaceRole } from "../api/types";

interface MembersState {
  list: Member[];
  loading: boolean;
}

interface MembersActions {
  loadList: () => Promise<void>;
  invite: (email: string) => Promise<Member>;
  remove: (id: number) => Promise<void>;
  changeRole: (id: number, role: WorkspaceRole) => Promise<void>;
  reset: () => void;
}

type Store = MembersState & MembersActions;

const INITIAL: MembersState = { list: [], loading: false };

export const useMembers = create<Store>((set) => ({
  ...INITIAL,

  async loadList() {
    set({ loading: true });
    try {
      const list = await api.listMembers();
      set({ list, loading: false });
    } catch (e) {
      set({ loading: false });
      throw e;
    }
  },

  async invite(email) {
    const created = await api.inviteMember(email);
    set((s) => ({ list: [...s.list, created] }));
    return created;
  },

  async remove(id) {
    await api.removeMember(id);
    set((s) => ({ list: s.list.filter((m) => m.id !== id) }));
  },

  async changeRole(id, role) {
    await api.changeMemberRole(id, role);
    set((s) => ({
      list: s.list.map((m) => (m.id === id ? { ...m, role } : m)),
    }));
  },

  reset() {
    set({ ...INITIAL });
  },
}));
